// Module
var code = "<div id=\"kform-htmlelement-{{ component.key }}\"> <div class=\"alert alert-warning\" ng-if=\"parseError\">{{ parseError }}</div> <div ng-bind-html=\"html\"></div> </div> ";
// Exports
export default code;